import { Components, Theme } from '@mui/joy';
import { S_ClipLoader } from '../../../design/loaders/clipLoader/S_ClipLoader';

declare module '@mui/joy/Button' {
  interface ButtonPropsVariantOverrides {
    transparent: true;
    topbar: true;
  }

  interface ButtonPropsSizeOverrides {
    xs: true;
    xl: true;
  }
}

export const JoyButtonConfig: Partial<Components<Theme>> = {
  JoyButton: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        const color = ownerState.color ?? 'primary';
        return {
          '&:disabled': {
            pointerEvents: 'auto',
          },
          ...(ownerState.size === 'md' && {
            '--Button-minHeight': '40px',
            fontSize: '1rem',
          }),
          borderRadius: '0.25rem',
          paddingBlock: '7px',
          paddingInline: '11px',
          border: '1px solid transparent',
          '&:hover:not([disabled])': {
            backgroundColor: theme.palette[color][400],
          },
          ...(ownerState.variant === 'solid' &&
            !ownerState.disabled && {
              borderColor: theme.palette[color][500],
              '&:hover:not([disabled])': {
                borderColor: theme.palette[color][600],
              },
            }),
          ...(ownerState.variant === 'outlined' && {
            border: '1px solid',
            backgroundColor: theme.palette.common.white,
            '&:disabled': {
              backgroundColor: theme.palette.neutral[200],
              pointerEvents: 'auto',
            },
            '&:hover:not([disabled])': {
              backgroundColor: theme.palette.neutral[100],
            },
            ...(ownerState.color === 'neutral' && {
              borderColor: theme.palette.neutral[300],
            }),
          }),
          ...(ownerState.variant === 'plain' && {
            '&:hover:not([disabled])': {
              backgroundColor: theme.palette[color][100],
            },
          }),
          ...(ownerState.variant === 'transparent' && {
            '&:not([disabled])': {
              color: theme.palette.common.white,
            },
            border: '1px solid',
            borderColor: theme.palette.common.white,
            backgroundColor: 'transparent',
            '&:hover:not([disabled])': {
              backgroundColor: 'transparent',
              '&:not([disabled])': {
                backgroundColor: theme.palette.neutral[800],
              },
            },
            '&:active': {
              backgroundColor: theme.palette.neutral[900],
            },
            '&:disabled': {
              ...(!ownerState.loading && {
                color: theme.palette.neutral[400],
              }),
              cursor: 'default',
            },
            '.MuiButton-loadingIndicatorCenter': {
              color: theme.palette.neutral[400],
            },
          }),
          ...(ownerState.size === 'xs' && {
            '--Icon-fontSize': '1rem',
            '--Button-gap': '0.25rem',
            '--Button-minHeight': '1.5rem',
            minHeight: 'var(--Button-minHeight, 1.5rem)',
            fontSize: theme.vars.fontSize.sm,
            paddingBlock: '2px',
            paddingInline: '0.5rem',
          }),
          ...(ownerState.variant === 'topbar' && {
            '--Icon-color': theme.palette.common.white,
            color: theme.palette.common.white,
            border: 'unset',
            backgroundColor: 'transparent',
            '&:hover:not([disabled])': {
              '--Icon-color': theme.palette.neutral[400],
              backgroundColor: 'transparent',
              color: theme.palette.neutral[400],
            },
            '&:active': {
              '--Icon-color': theme.palette.neutral[500],
              color: theme.palette.neutral[500],
            },
            '&:disabled': {
              '--Icon-color': theme.palette.neutral[500],
              color: theme.palette.neutral[500],
            },
          }),
        };
      },
      loadingIndicatorCenter: () => {
        return {
          maxHeight: '80%',
        };
      },
    },
    defaultProps: {
      loadingIndicator: <S_ClipLoader />,
    },
  },
};
